const { computed } = require('mobx');
const { inject, observer } = require('mobx-react');
const { Link } = require('react-router-dom');
const React = require('react');

const { AbacusControl, AbacusExperiment, AbacusVariant } = require('bernie-abacus');
const { ClickTracker } = require('bernie-analytics');
const { ErrorBoundary, Layer, ViewExtraLarge, ViewLarge, ViewMedium, Viewport, ViewSmall } = require('bernie-view');
const { QueryRoute } = require('bernie-core');
const { withLocalization } = require('bernie-l10n');

/* global document, CustomEvent */

const { PageName } = require('constants/pages');

const { classNames } = require('uitk-react-utils');
const { liveAnnounce } = require('uitk-react-utils');
const { UitkLayoutFlex, UitkLayoutFlexItem } = require('uitk-react-layout-flex');
const { UitkSecondaryButton } = require('uitk-react-button');

const { ChangeSearchDialog } = require('components/search/change-search-dialog');
const { ExitIntent } = require('components/search/exit-intent');
const { LoyaltyEducationDialog } = require('components/common/loyalty-education/loyalty-education-dialog');
const { MainRegion } = require('components/layout/pages/main-region');
const { MasterPage } = require('components/layout/pages/master-page');
const { MesoFooter } = require('components/meso/meso-footer');
const { MesoIntentMediaExp } = require('components/meso/meso-intent-media-exp');
const { MesoSideRail } = require('components/meso/meso-side-rail');
const { Overlay } = require('components/layout/layers/overlay');
const { Playback } = require('components/search/playback/playback');
const { Results } = require('components/search/results');
const { RewardsEducationDialog } = require('components/common/rewards-education-dialog');
const { SearchResultsMap } = require('components/search/map');
const { Sidebar } = require('components/search/sidebar.tsx');
const { SideRailRegion } = require('components/layout/pages/side-rail-region');
const { ToolbarRegion } = require('components/layout/pages/toolbar-region');
const { Tools } = require('components/search/tools.tsx');
const ViewportListener = require('components/common/lazy/viewport-listener.js');

const MasterPageToolbarTypes = MasterPage.wrappedComponent.toolbarTypes;

const ButtonTracked = ClickTracker(UitkSecondaryButton);
const MasterPageSideRailTypes = MasterPage.wrappedComponent.sideRailTypes;
@withLocalization
@inject(
  'searchResults',
  'page',
  'layerManager',
  'context',
  'uiPage',
  'analytics',
  'routeStore',
  'shortlist',
  'experiment',
  'customerInterestsStore',
  'multiItem'
)
@observer
class Search extends React.Component {
  resultRefs = [];
  renderRemainingAfterIndex = 9;

  constructor(props) {
    super(props);
    this.handleOnDismiss = this.handleOnDismiss.bind(this);
    this.setResultRef = this.setResultRef.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.getMultiPropertyHeader = this.getMultiPropertyHeader.bind(this);
    this.prevLoading = false;
    this.state = {
      jsEnabled: false
    };

    if (
      this.props.searchResults &&
      this.props.searchResults.searchCriteria &&
      this.props.searchResults.searchCriteria.multiProp === 'true'
    ) {
      this.props.multiItem && this.props.multiItem.getOrCreateCart(this.props.context);
    }
  }

  @computed.struct
  get omnitureData() {
    if (this.props.searchResults && this.props.analytics) {
      const resultsOmnitureData = this.props.searchResults.omnitureData || null;

      if (resultsOmnitureData) {
        // use mergeOmnitureData even with one source to ensure the data is properly formatted and de-referenced
        const mergedData = this.props.analytics.mergeOmnitureData(resultsOmnitureData);

        return mergedData;
      }
    }

    return null;
  }

  @computed.struct
  get universalDataObject() {
    if (this.props.searchResults && typeof this.props.searchResults.universalDataObject === 'object') {
      return this.props.searchResults.universalDataObject;
    }

    return {};
  }

  get backToChangeSearchQuery() {
    const { routeStore } = this.props;
    if (routeStore && typeof routeStore.mergeQueryString === 'function') {
      return routeStore.mergeQueryString(routeStore.search, { pwaOverlay: 'changeSearch' });
    }
  }

  get loading() {
    const { searchResults, uiPage } = this.props;

    return searchResults.isLoading && !uiPage.displayProgressIndicator;
  }

  componentDidMount() {
    const { analytics, multiItem, context } = this.props;
    analytics.markPageUsable();
    this.announceLoadingState();
    this.trackDisambiguationSearch();
    this.setState({
      jsEnabled: true
    });
    if (multiItem && multiItem.cartInfo && multiItem.cartInfo.identifier === 'mixAndMatch' && multiItem.itemCount > 0) {
      multiItem.emptyCart(context);
    }
  }

  trackDisambiguationSearch() {
    if (this.props.multiItem && this.props.multiItem.isDisambigSearch()) {
      if (this.props.analytics && typeof this.props.analytics.trackEvent === 'function') {
        const events = [{ name: 'SearchResultsDisambig', error: false }];
        this.props.analytics.trackEvent(
          this.props.multiItem.referrer,
          'package disambig search',
          this.props.searchResults.omnitureData,
          events
        );
      }
    }
  }

  componentDidUpdate() {
    this.announceLoadingState();
    this.markPageUsableOnUpdate();
  }

  markPageUsableOnUpdate() {
    const { isLoading } = this.props.searchResults;
    if (isLoading === false && this.prevLoading === true) {
      this.props.analytics.markPageUsable();
    }
    this.prevLoading = isLoading;
  }

  announceLoadingState() {
    const { isLoading, isError, isEmpty } = this.props.searchResults;
    const { l10n } = this.props;

    let message;
    if (isLoading) {
      message = l10n.formatText('hotels.searchResults.resultsLoading.liveAnnounce');
    } else if (isError) {
      message = l10n.formatText('hotels.searchResults.errorRetrievingResults.liveAnnounce');
    } else if (isEmpty) {
      message = l10n.formatText('hotels.searchResults.emptyResults.liveAnnounce');
    } else {
      message = l10n.formatText('hotels.searchResults.resultsUpdated.liveAnnounce');
    }
    if (message !== this.lastLoadingStateMessage) {
      liveAnnounce(message, 'assertive');
      this.lastLoadingStateMessage = message;
    }
  }

  handleOnDismiss() {
    const { routeStore } = this.props;
    if (routeStore && typeof routeStore.goBack === 'function') {
      routeStore.goBack();
    }
  }

  setResultRef(ref, index) {
    this.resultRefs[index] = ref;

    if (index === this.renderRemainingAfterIndex && ref !== null) {
      ViewportListener.subscribe(
        'window',
        ref,
        {
          didEnter: () => this.props.searchResults.setHotelsMaxDisplayToTotalRenderCount()
        },
        { extendBoundingBoxToBottomOfPage: true, triggerOnce: true }
      );
    }
  }

  getMultiPropertyHeader() {
    const { multiItem, l10n } = this.props;

    if (multiItem && multiItem.isFreshCart) {
      return l10n && l10n.formatText('hotels.searchResults.multiProperty.first.header');
    }

    if (multiItem && multiItem.isTouchedCart) {
      return l10n && l10n.formatText('hotels.searchResults.multiProperty.next.header');
    }
  }

  render() {
    return (
      <Viewport>
        <ViewSmall>{this.renderLayout(false)}</ViewSmall>
        <ViewExtraLarge>
          <AbacusExperiment name="SRP_Split_View_Listing_Map">
            <AbacusControl>{this.renderLayout(false)}</AbacusControl>
            <AbacusVariant bucket={1}>{this.renderLayout(true)}</AbacusVariant>
          </AbacusExperiment>
        </ViewExtraLarge>
      </Viewport>
    );
  }

  renderResults(largeGridColumnCount = 3) {
    const {
      hotels,
      hotelsMaxDisplay,
      insights,
      isLoading,
      maxHotelsDisplayedPerLoad,
      messages,
      overFilteredModel,
      searchCriteria,
      splitListings
    } = this.props.searchResults;
    const { endDate, startDate } = searchCriteria;
    const { l10n, routeStore, analytics } = this.props;
    const { hotelListings, messageListings } = splitListings(hotels, messages);
    const allHotelsDisplayed = hotels ? hotelsMaxDisplay >= hotelListings.length : true;
    const disableShowMore = isLoading || allHotelsDisplayed || !this.state.jsEnabled;
    const pageLoadNumber = hotelsMaxDisplay / maxHotelsDisplayedPerLoad;
    const loadMoreRfrr = `:LoadMore${pageLoadNumber}`;
    const resultsClassName = `uitk-cell xl-cell-1-${largeGridColumnCount} l-cell-1-${largeGridColumnCount} m-cell-1-1 s-cell-1-1`;
    const buttonProps = {
      rfrr: loadMoreRfrr,
      linkName: 'Show more results',
      disabled: disableShowMore,
      text: l10n.formatText('hotels.searchResults.paginationButton.label')
    };
    const multiPropertyGuidanceHeader = this.getMultiPropertyHeader();

    return (
      <React.Fragment>
        {/* TODO: Move show more button into hotel list */}
        <h2 className="is-visually-hidden">{l10n.formatText('hotels.search.results.heading')}</h2>
        {!overFilteredModel && <MultiPropertyGuidanceHeader multiPropertyGuidanceHeader={multiPropertyGuidanceHeader} />}
        <Results
          className={resultsClassName}
          endDate={endDate}
          hotelListings={hotelListings}
          hotels={hotels}
          insights={insights}
          loading={this.loading}
          messageListings={messageListings}
          messages={messages}
          searchResults={this.props.searchResults}
          setResultRef={this.setResultRef}
          startDate={startDate}
          routeStore={routeStore}
          analytics={analytics}
        />
        <ShowMoreButton allHotelsDisplayed={allHotelsDisplayed} buttonProps={buttonProps} onClickHandler={this.handleShowMore} />
        {this.renderErrorMessage()}
        <MesoFooter pageName={PageName.SEARCH} destination={this.resolveDestination()} />
      </React.Fragment>
    );
  }

  refreshAds() {
    if (document && CustomEvent && typeof document.dispatchEvent === 'function') {
      document.dispatchEvent(new CustomEvent('mesoTriggeredRefresh', { detail: { type: 'impressionRefresh' } }));
    }
  }

  showMoreHotels() {
    const { analytics, context, customerInterestsStore, multiItem, searchResults } = this.props;
    this.props.uiPage.showProgressIndicator(400);

    const customerInterests = customerInterestsStore ? customerInterestsStore.customerInterests : null;

    searchResults.showMoreHotels(analytics, context, customerInterests, multiItem).then(previousMax => {
      // Move focus to the first newly revealed HSR cards, for better screen reader experience.
      this.resultRefs[previousMax].focus();
    });
  }

  handleShowMore() {
    this.refreshAds();
    this.showMoreHotels();
  }

  renderErrorMessage() {
    const searchResults = this.props.searchResults || {};
    const { hotels, isError, isEmpty } = searchResults;
    const destination = this.resolveDestination();
    const { l10n } = this.props;

    const hasAvailableHotels = hotels && hotels.length > 0;

    if (isError || isEmpty) {
      const errorMessage = isError
        ? l10n.formatText('hotels.searchResults.error.text')
        : l10n.formatText('hotels.searchResults.destinationMissing.message');

      return (
        <div className="uitk-type-center all-b-padding-twelve">
          <ErrorContainer errorMessage={errorMessage} />
          {!destination &&
            hasAvailableHotels && (
              <BackToChangeSearch
                analytics={this.props.analytics}
                l10n={l10n}
                onDismiss={this.handleOnDismiss}
                query={this.backToChangeSearchQuery}
              />
            )}
        </div>
      );
    }

    return null;
  }

  resolveDestination() {
    const { searchedDestination, searchCriteria } = this.props.searchResults;

    return searchCriteria.destination || searchedDestination;
  }

  renderLayout(flexLayoutSplitView) {
    const { analytics, page, l10n, searchResults, multiItem } = this.props;

    const destinationTitle = this.resolveDestination();
    const mainRegionClasses = classNames('search-results__main', { 'main-region all-x-padding-two': !flexLayoutSplitView });

    page.title = destinationTitle
      ? l10n.formatText('hotels.searchResults.successfulSearch.pageTitle', destinationTitle)
      : l10n.formatText('hotels.searchResults.invalidSearch.pageTitle');

    const rewardsEducation = searchResults && searchResults.rewardsDialogContent && searchResults.rewardsDialogContent.rewardsEducation;
    const loyaltyEducation = searchResults && searchResults.loyaltyEducation;
    const searchResultsClasses = classNames('search-results-listing', { 'all-y-padding-three': !flexLayoutSplitView });
    const masterPageClasses = classNames('search-results', { 'split-view': flexLayoutSplitView });

    return (
      <MasterPage
        className={masterPageClasses}
        loading={this.loading}
        route={this.props.route}
        searchCriteria={searchResults.searchCriteria}
        sideRailType={MasterPageSideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR}
        toolbarType={flexLayoutSplitView ? MasterPageToolbarTypes.TOOLBAR_WHITE_BACKGROUND : MasterPageToolbarTypes.NORMAL}
        flexLayoutSplitView={flexLayoutSplitView}
      >
        <ToolbarRegion className="search-results-toolbar">
          <Playback bookingNextProperty={multiItem && multiItem.isTouchedCart} />
        </ToolbarRegion>
        <MainRegion className={mainRegionClasses}>
          <div className={`${searchResultsClasses} m-t-padding-one`}>
            <Viewport>
              <ViewSmall>
                {!flexLayoutSplitView && <ErrorBoundaryWrappedTools analytics={analytics} />}
                {this.renderResults()}
              </ViewSmall>
              <ViewMedium>
                {!flexLayoutSplitView && <ErrorBoundaryWrappedTools analytics={analytics} />}
                {this.renderResults(1)}
              </ViewMedium>
              <ViewLarge>
                <LargeSearchResults jsEnabled={this.state.jsEnabled} results={this.renderResults(1)} showTools={true} />
              </ViewLarge>
              <ViewExtraLarge>
                <ExtraLargeSearchResults
                  analytics={analytics}
                  flexLayoutSplitView={flexLayoutSplitView}
                  jsEnabled={this.state.jsEnabled}
                  results={this.renderResults(1)}
                  showTools={true}
                  searchResults={searchResults}
                />
              </ViewExtraLarge>
            </Viewport>
          </div>
          <MesoIntentMediaExp pageName={PageName.SEARCH} searchCriteria={searchResults.searchCriteria} />
          <QueryRoute query={{ pwaDialog: 'rewardsEducation' }}>
            <RewardsEducationDialog rewardsEducation={rewardsEducation} />
          </QueryRoute>
          <QueryRoute query={{ pwaDialog: 'loyaltyEducation' }}>
            <LoyaltyEducationDialog loyaltyEducation={loyaltyEducation} />
          </QueryRoute>
          {searchResults.exitIntent && (
            <AbacusExperiment name="LShop_SRP_limit_comet_exit_intent">
              <AbacusControl>
                <ExitIntent showOnce={false} exitIntent={searchResults.exitIntent} />
              </AbacusControl>
              <AbacusVariant bucket={1}>
                <ExitIntent showOnce={true} exitIntent={searchResults.exitIntent} />
              </AbacusVariant>
            </AbacusExperiment>
          )}
        </MainRegion>
        <SideRailRegion>
          <MesoSideRail pageName={PageName.SEARCH} />
        </SideRailRegion>
      </MasterPage>
    );
  }
}

const LargeSearchResults = ({ analytics, jsEnabled, results, showTools }) => (
  <div className="uitk-grid">
    <div className="uitk-cell all-cell-1-4">
      <Sidebar isActive={jsEnabled} />
    </div>
    <div className="uitk-cell all-cell-3-4 all-x-gutter-six">
      {showTools && <ErrorBoundaryWrappedTools analytics={analytics} />}
      {results}
    </div>
  </div>
);

const ExtraLargeSearchResults = ({ analytics, flexLayoutSplitView, jsEnabled, results, showTools, searchResults }) => (
  <>
    {!flexLayoutSplitView && (
      <div className="uitk-grid">
        <div className="uitk-cell all-cell-1-4">
          <Sidebar isActive={jsEnabled} />
        </div>
        <div className="uitk-cell all-cell-3-4 all-x-gutter-six">
          {showTools && <ErrorBoundaryWrappedTools analytics={analytics} />}
          {results}
        </div>
      </div>
    )}
    {flexLayoutSplitView && (
      <UitkLayoutFlex>
        <UitkLayoutFlexItem className="xl-r-margin-six" grow={1} minWidth={330}>
          <div>{searchResults && searchResults.map && <SearchResultsMap splitView={flexLayoutSplitView} />}</div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem className="xl-t-margin-four split-view-listings" grow={2} minWidth={660}>
          <div>
            <ErrorBoundary label="hotel.search.tools">
              <Tools analytics={analytics} withFilterButton={flexLayoutSplitView} />
            </ErrorBoundary>
            {results}
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    )}
  </>
);

const ErrorBoundaryWrappedTools = ({ analytics }) => (
  <ErrorBoundary label="hotel.search.tools">
    <Tools analytics={analytics} />
  </ErrorBoundary>
);

const ErrorContainer = ({ errorMessage, children }) => (
  <div className="uitk-type-300 pwa-theme--grey-700 uitk-type-center search-results-error">
    <p>{errorMessage}</p>
    {children}
  </div>
);

const BackToChangeSearch = ({ analytics, onDismiss, query, l10n }) => (
  <div className="backToChangeSearch">
    <ButtonTracked
      linkName="Back to change search"
      rfrr=":destinationMissingChangeSearch"
      tag={Link}
      text={l10n.formatText('header.search.linkText')}
      to={{ search: query }}
    />

    <QueryRoute query={{ pwaOverlay: 'changeSearch' }}>
      <Layer id="destination-missing-changesearch" onDismiss={onDismiss}>
        <Overlay type="takeover" openAnimation="slideup">
          <ChangeSearchDialog analytics={analytics} onDismiss={onDismiss} />
        </Overlay>
      </Layer>
    </QueryRoute>
  </div>
);

const ShowMoreButton = ({ allHotelsDisplayed, buttonProps, onClickHandler }) => {
  if (allHotelsDisplayed) {
    return null;
  }

  return (
    <ErrorBoundary label="hotel.search.showMoreResultsButton">
      <section className="uitk-flex uitk-flex-justify-content-center all-t-padding-three">
        <ButtonTracked {...buttonProps} data-stid="show-more-results" onClick={onClickHandler} />
      </section>
    </ErrorBoundary>
  );
};

const MultiPropertyGuidanceHeader = ({ multiPropertyGuidanceHeader }) => {
  if (!multiPropertyGuidanceHeader) {
    return null;
  }

  return (
    <h3 className="uitk-type-500 all-b-padding-two" data-stid="multi-property-guidance-header">
      {multiPropertyGuidanceHeader}
    </h3>
  );
};

module.exports = Search;
